import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class FontLoaderService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  loadFonts() {
    if (isPlatformBrowser(this.platformId)) {
      const fonts = [
        'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap',
        'https://fonts.googleapis.com/css?family=Merriweather:400,300,700,900',
        'https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap',
        'https://fonts.googleapis.com/icon?family=Material+Icons',
      ];

      fonts.forEach((href) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      });
    }
  }
}
